import { supabase } from "@/integrations/supabase/client";
import { playNotificationSound } from "@/lib/notificationSounds";
import { NotificationToast } from "@/components/notifications/NotificationToast";
import { toast } from "sonner";
import React from "react";

// Global dedup set — shared with useNotificationListener
const recentLocalIds = new Set<string>();

export function getRecentLocalIds(): Set<string> {
  return recentLocalIds;
}

interface NotifyParams {
  user_id: string;
  title: string;
  message: string;
  type?: string;
  severity?: "info" | "success" | "warning" | "urgent";
  link?: string | null;
  read?: boolean;
}

/**
 * Insert a notification into the database AND immediately fire
 * a local toast + sound. This avoids relying on Supabase Realtime
 * for self-inserts (which can be unreliable).
 */
export async function notifyAndToast(params: NotifyParams) {
  const { severity = "info", ...rest } = params;

  const { data, error } = await supabase
    .from("notifications")
    .insert({ ...rest, severity } as any)
    .select("id")
    .single();

  if (error) {
    console.error("[notifyAndToast] insert failed:", error.message);
    return;
  }

  // Track the ID so the realtime listener can skip it (dedup)
  if (data?.id) {
    recentLocalIds.add(data.id);
    setTimeout(() => recentLocalIds.delete(data.id), 10000);
  }

  // Immediately show toast + play sound
  toast.custom(
    (id) =>
      React.createElement(NotificationToast, {
        id,
        title: params.title,
        message: params.message,
        severity,
        link: params.link,
      }),
    { duration: 6000 }
  );

  playNotificationSound("chime");
}
